package com.karyadina.model

import kotlinx.serialization.Serializable

/**
 * Pomodoro timer session type
 */
enum class SessionType {
    FOCUS,      // 25 minutes focus time
    SHORT_BREAK, // 5 minutes break
    LONG_BREAK  // 15-30 minutes break
}

/**
 * Pomodoro timer state
 */
enum class TimerState {
    IDLE,
    RUNNING,
    PAUSED,
    COMPLETED
}

/**
 * Pomodoro timer configuration
 */
@Serializable
data class PomodoroConfig(
    val focusDuration: Int = 25, // minutes
    val shortBreakDuration: Int = 5, // minutes
    val longBreakDuration: Int = 15, // minutes
    val sessionsBeforeLongBreak: Int = 4,
    val autoStartBreaks: Boolean = false,
    val autoStartPomodoros: Boolean = false,
    val enableSound: Boolean = true,
    val enableVibration: Boolean = true
)

/**
 * Pomodoro session data
 */
@Serializable
data class PomodoroSession(
    val id: String,
    val sessionType: String = SessionType.FOCUS.name,
    val startTime: Long,
    val endTime: Long? = null,
    val durationMinutes: Int,
    val completed: Boolean = false,
    val interrupted: Boolean = false,
    val task: String? = null,
    val createdAt: Long = com.karyadina.util.currentTimeMillis(),
    val updatedAt: Long = com.karyadina.util.currentTimeMillis()
)

/**
 * Pomodoro statistics
 */
@Serializable
data class PomodoroStats(
    val totalSessions: Int = 0,
    val completedSessions: Int = 0,
    val totalFocusTime: Long = 0, // minutes
    val todayFocusTime: Long = 0,
    val weeklyFocusTime: Long = 0,
    val currentStreak: Int = 0,
    val longestStreak: Int = 0
)
